















import { Mixins } from "vue-property-decorator";
import { Mobile } from "@/mixins/mobile";

export default class AccordionSectionCheckout extends Mixins(Mobile) {}
